import { MapService } from '../../services/gmap/map.service';
import { constantes } from '../../constantes';
import { ParamsService } from '../../services/params.service';
import { InfoService } from '../../interfaces/infoservice.interface';
import { Service } from '../../interfaces/service.interface';
import { Company } from '../../interfaces/company.interface';
import { environment } from '../../../environments/environment';
import { DataService } from '../../services/data.service';
import { ApplicationRef, Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import {} from '@types/googlemaps';
import { Math2 } from 'src/app/classes/math2.class';
import { BreakpointObserver } from '@angular/cdk/layout';
// import * as MarkerClusterer from 'node-js-marker-clusterer';


declare var google;
declare var MarkerClusterer:any;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {
	
	
	
	@ViewChild('map') mapElement: ElementRef;
	
	map: google.maps.Map;
	mkcrCompany:any;
	mkcrInfos:any;
	mkcrServices:any;
	markers:google.maps.Marker[];
	isRetina:boolean;
	
	selectedMarker: any;
	modalVisible:boolean;
	markerAddress:any;
	position: google.maps.Point;
	
	// sectors:any[] = [];
	
	
	binit:boolean = false;
	
	@Input() showCompany:boolean;
	@Input() showService:boolean;
	@Input() showInfos:boolean;
	@Input() showRoute: boolean;
	@Input() showAddress:boolean;
	@Input() selectedSectors:any;
	@Input() showSectors:boolean;
	
	@Input() companies:Company[];
	@Input() services:Service[];
	@Input() infos:InfoService[];
	
	INIT_ZOOM:number = 13;
	// MIN_ZOOM:number = 12;
	MIN_ZOOM:number = 5;
	LOCALIZE_ZOOM:number = 18;
	kmlLayers:any = {};
	
	modalHeight:number;
	mobile:boolean;
	
	
  constructor(
		public dataService:DataService,
		private paramsService:ParamsService,
		private app: ApplicationRef,
		private _elementRef : ElementRef,
		private breakpointObserver: BreakpointObserver,
		private mapService:MapService,
	) { 
		this.paramsService.addListener('localize', this.onLocalize.bind(this));
		this.paramsService.addListener('getAddress', this.onGetAddress.bind(this));
	}
	
	
	
	
  ngOnInit() {
	
		let latlng:google.maps.LatLng = new google.maps.LatLng(constantes.locationInit.lat, constantes.locationInit.lng);
		this.isRetina = this.breakpointObserver.isMatched(['(-webkit-min-device-pixel-ratio: 1.5)', '(min-resolution: 144dpi)']);
		console.log('isRetina : '+this.isRetina);
		
		let mobile:boolean = this.breakpointObserver.isMatched('(max-width: 768px)');
		this.mobile = mobile;
		
		let mapOptions:google.maps.MapOptions = {
			center: latlng,
			zoom: this.INIT_ZOOM,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			minZoom: (environment.production || true) ? this.MIN_ZOOM : 1,
			gestureHandling: "greedy",
			styles : [ { "featureType": "administrative.locality", "stylers": [ { "visibility": "off" } ] },{ "featureType": "road.highway", "stylers": [ { "hue": "#ff8800" }, { "saturation": -73 }, { "lightness": 40 } ] },{ "featureType": "road.arterial", "stylers": [ { "saturation": -30 }, { "lightness": 22 } ] },{ "featureType": "transit.station.rail", "stylers": [ { "visibility": "off" } ] },
			{"featureType": "poi", "stylers": [{"visibility": "off"}]} ],
			
			panControl: false,
			zoomControl: !mobile,
			zoomControlOptions: {
				style: google.maps.ZoomControlStyle['DEFAULT'],
				position: google.maps.ControlPosition['RIGHT_BOTTOM']
			},
			mapTypeControl: !mobile,		//plan-satellite
			mapTypeControlOptions: {
				style: google.maps.ZoomControlStyle['DEFAULT'],
				position: google.maps.ControlPosition['TOP_RIGHT']
			},
			scaleControl: false,
			streetViewControl: !mobile,
			overviewMapControl: false,
			fullscreenControl: false,
			
		};
		
		this.paramsService.addListener('route', this.onClickRoute.bind(this));
		
		if(environment.enableMap){
			this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
			google.maps.event.addListener(this.map, 'zoom_changed', this.onZoomChange.bind(this));
			google.maps.event.addListener(this.map, 'center_changed', this.onMapMove.bind(this));
			
			this.dataService.map = this.map;
			
			
			
			this.kmlLayers = {};
			
			constantes.sectors.forEach(function(obj){
				
				let letter:string = obj.value.toLowerCase();
				// if(["a", "b", "c", "d"].indexOf(letter) == -1) return;
				
				// var url:string = constantes.onlineBaseUrl + 'assets/kml/sector-'+letter+'.kml';
				var url:string = constantes.onlineBaseUrl + 'assets/kml/sector-'+letter+'.kmz';
				if(environment.debug) url += "?dummy="+(new Date()).getTime();
				// debugger;
				
				var kmlLayer:google.maps.KmlLayer = new google.maps.KmlLayer({
					url,
					suppressInfoWindows: true,
					preserveViewport: true,
					map: this.map
				});
				kmlLayer.addListener('metadata_changed', function(){
					
					if(this.kmlLayers[obj.value]) return;
					
					let bounds:google.maps.LatLngBounds = kmlLayer.getDefaultViewport();
					let ne:google.maps.LatLng = bounds.getNorthEast();
					let sw:google.maps.LatLng = bounds.getSouthWest();
					let markerCoord:number[] = [(ne.lat() + sw.lat()) / 2, (ne.lng() + sw.lng()) / 2]
					markerCoord[0] += obj.shiftLetterLocation[0] / 1000;
					markerCoord[1] += obj.shiftLetterLocation[1] / 1000;
					
					
					let marker:any = new google.maps.Marker({
						position: this.array2latlng(markerCoord),
						map: this.map,
						icon: new google.maps.MarkerImage(
								'assets/images/markers/letters/'+letter+'@2x.png',
								new google.maps.Size(30,45), //size
								null, //origin
								null, //anchor
								new google.maps.Size(30,45),
						)
					});
					marker.type = 'sector';
					
					this.kmlLayers[obj.value] = {kmlLayer, marker, visible:true};
					
					this.onZoomChange();
					
				}.bind(this));
				
				
				
			}.bind(this));
			
			
			
		}
		
	}
	
	
	
	
	
	
	initMap():void
	{
		this.markers = [];
		
		
		
		
		//add markers services
		this.services.forEach((item:Service) => {
			if(item.latlng){
				let location = this.array2latlng(item.latlng);
				
				let serviceKey:string = this.getServiceKey(item.type);
				let png:string = serviceKey ? 'marker-service-'+serviceKey : '';
				// console.log('png : '+png);
				
				let markersize:number[] = this.getServiceMarkerSize(item.type);
				
				if(png) this.addMarker(location, png, item, 'service', markersize[0], markersize[1]);
				else{
					//type service null ?
					//  debugger;
				}
			}
		});
		
		
		
		//add markers companies
		this.companies.forEach((item:Company) => {
			if(item.latlng){
				let location = this.array2latlng(item.latlng);
				this.addMarker(location, 'marker-company', item, 'company', 47, 60);
			}
		});
		
		
		//add markers infos
		this.infos.forEach((item:InfoService) => {
			
			item.listLatlng.forEach((latlng:number[]) => {
				let location = this.array2latlng(latlng);
				this.addMarker(location, 'marker-info', item, 'infos', 33, 33);
			});
		});
		
		
	}
	
	
	
	
	
	
	ngOnChanges(changes:SimpleChanges):void
	{
		if(this.companies && this.services && this.infos){
			
			
			
			//init markers
			
			if(!this.binit){
				this.binit = true;
				this.initMap();
				
				/* 	
				if(environment.debug){
					let first:boolean = true;
					google.maps.event.addListenerOnce(this.map, 'idle', function(){
						
						if(!first) return;
						this.onGetAddress({lat: 49.129170, lng: 2.267110, address: 'test address'});
						first = false;
							
					}.bind(this));
				}
				 */
				
			}
			
			
			//update visibility
			
			this.markers.forEach((marker:any) => {
				
				let item:any = (<any>marker).item;
				let type:string = (<any>marker).type;
				
				if(type == 'company' && (changes.showCompany || changes.companies)){
					
					let visible:boolean = (this.showCompany && item.visible);
					if(marker.visible2 != visible){
						
						marker.setVisible(visible);
						marker.visible2 = visible;
					}
					// debugger;
				}
				else if(type == 'service' && (changes.showService || changes.services)){
					let visible:boolean = (this.showService && item.visible);
					marker.setVisible(visible);
					marker.visible2 = visible;
				}
				else if(type == 'infos' && (changes.showInfos || changes.infos)){
					let visible:boolean = (this.showInfos && item.visible);
					marker.setVisible(visible);
					marker.visible2 = visible;
					
				}
				else if(type == 'address'){
					let visible:boolean = (this.showAddress && item.visible);
					marker.setVisible(visible);
					marker.visible2 = visible;
				}
				
				
			});
			
			
			//init clusterers
			
			if(!this.mkcrInfos) this.mkcrInfos = this.createMarkerClusterer('clusterer-info', false, 42);
			if(!this.mkcrServices) this.mkcrServices = this.createMarkerClusterer('clusterer-service', true, 62);
			if(!this.mkcrCompany) this.mkcrCompany = this.createMarkerClusterer('clusterer', true, 62);
			
			
			//upate clusterers
			
			let markers:google.maps.Marker[];
			
			if(changes.showCompany || changes.companies){
				
				markers = this.filterMarkerVisible('company');
				if(this.mkcrCompany.getTotalMarkers() > 0) this.mkcrCompany.clearMarkers();
				markers.forEach(marker => this.mkcrCompany.addMarker(marker));
				
			}
			
			
			if(changes.showService || changes.services){
				
				markers = this.filterMarkerVisible('service');
				if(this.mkcrServices.getTotalMarkers() > 0) this.mkcrServices.clearMarkers();
				markers.forEach(marker => this.mkcrServices.addMarker(marker));
				
			}
			
			
			if(changes.showInfos || changes.infos){
				markers = this.filterMarkerVisible('infos');
				if(this.mkcrInfos.getTotalMarkers() > 0) this.mkcrInfos.clearMarkers();
				// this.mkcrInfos.addMarkers(markers);
				markers.forEach(marker => this.mkcrInfos.addMarker(marker));
				// debugger;
			}
			
			
			if(changes.showSectors || changes.selectedSectors){
				
				for(var k in this.kmlLayers){
					let kmlLayer:google.maps.KmlLayer = this.kmlLayers[k].kmlLayer;
					let marker:google.maps.KmlLayer = this.kmlLayers[k].marker;
					let obj:any = this.kmlLayers[k];
					let visible:boolean = (this.showSectors && this.selectedSectors[k]);
					// debugger;
					
					if(obj.visible != visible){
						/* 
						let dummy = this._elementRef.nativeElement.querySelector("img[src*='kml']");
						dummy.style.opacity = 0.3;
						debugger;
						 */
						
						kmlLayer.setMap(visible ? this.map : null);
						// kmlLayer.set('opacity', visible ? 1 : 0);
						marker.setMap(visible ? this.map : null);
						obj.visible = visible;
					}
				}
				// debugger;
			}
			
			
			
			
		}
	}
	
	
	private updateMarkerClusterers(mkcr:any ,markers:google.maps.Marker[]):void
	{
		let oldmarkers:google.maps.Marker[] = mkcr.getMarkers();
		
		//delete old markers
		oldmarkers.forEach((marker) => {
			if(markers.indexOf(marker) == -1) mkcr.removeMarker(marker);
		});
		
		//add new markers
		markers.forEach((marker) => {
			if(oldmarkers.indexOf(marker) == -1) mkcr.addMarker(marker);
		});
	}
	
	
	
	private filterMarkerVisible(type:string):google.maps.Marker[]
	{
		let markers:google.maps.Marker[];
		markers = this.markers.filter(marker => {
			let item:Company = (<any>marker).item;
			let t:string = (<any>marker).type;
				
			// return (t == type && marker.getVisible());
			return (t == type && (<any>marker).visible2);
		});
		return markers;
	}
	
	
	
	private addMarker(location:google.maps.LatLng, png:string, item:any, type:string, width:number, height:number) 
	{
		if(this.isRetina) png += '@2x';
		
		 var marker:google.maps.Marker = new google.maps.Marker({
				 position: location, 
				 map: this.map,
				 icon: {
					 url: 'assets/images/markers/' + png + '.png',
					 size: new google.maps.Size(width, height),
					 scaledSize: new google.maps.Size(width, height),
				 }
				 
		 });
		 
		 google.maps.event.addListener(marker, "click", function (e) {
			 this.onClickMarker(marker);
		 }.bind(this));
		 
		 this.markers.push(marker);
		 (<any>marker).item = item;
		 (<any>marker).type = type;
		 (<any>marker).visible2 = true;
		 
		 return marker;
	 }
	 
	 
	 
	 
	 
	 private getServiceKey(dbvalue:string):string
	 {
		 for(let k in constantes.serviceTypes){;
			 let item = constantes.serviceTypes[k];
			 if(item.dbvalue == dbvalue) return item.id;
		 }
		 return null;
	 }
	 
	 private getServiceMarkerSize(dbvalue:string):number[]
	 {
		 for(let k in constantes.serviceTypes){;
			 let item = constantes.serviceTypes[k];
			 if(item.dbvalue == dbvalue) return item.markerSize;
		 }
		 return null;
	 }
	 
	 
	 
	 private removeMarker(marker:google.maps.Marker)
	 {
		 marker.setMap(null);
		 var index = this.markers.indexOf(marker);
		 if(index != -1) this.markers.splice(index, 1);
		 console.log(this.markers);
	 }
	 
	 
	 
	 private onClickMarker(marker):void
	 {
		 this.selectedMarker = marker;
		 this.modalVisible = false;
		 
		 this.app.tick();
		 
		 //todo : dans l'idéal : event qui détermine qd la taille a changé
		 setTimeout(function() {
			 this.onClickMarker2(marker);
		 }.bind(this), 50);
		}
	 
		
	 private onClickMarker2(marker):void
	 {
		 if(marker.item) console.log('onClickMarker '+marker.item.name || marker.item.title);
		 else console.log('onClickMarker null');
		 
			//  debugger;
			let modalWidth:number = 0;
			let modalDom = this._elementRef.nativeElement.querySelector('app-modal');
			if(modalDom){
				this.modalHeight = modalDom.clientHeight;
				modalWidth = modalDom.clientWidth;
			}
			
			let mapDom = this._elementRef.nativeElement.querySelector('div.map');
			let mapWidth:number = mapDom.clientWidth;
			let mapHeight:number = mapDom.clientHeight;
			
			//desired position
			let mobile:boolean = this.breakpointObserver.isMatched('(max-width: 768px)');
			if(mobile) mapHeight -= 150;
			
			
			let x:number = mapWidth * 0.5 - modalWidth * 0.5;
			let y:number = mapHeight * 0.5 - this.modalHeight * 0.5;
			
			//si desktop && sidebar
			if(!mobile){
				
				let openSidebar:boolean = this.paramsService.getData('openSidebar');
				// debugger;
				if(openSidebar){
					let width_sidebar:number = 533;
					x = width_sidebar + (mapWidth - width_sidebar) * 0.5 - modalWidth * 0.5;
				}
			}
			
			if(y < 0) y = 0;
			
			x += 114;
			y += this.modalHeight + 48;
			
			
			if(mobile){
				x = mapWidth * 0.5;
				y = (mapHeight) * 0.5;
			}
			
			
			this.position = this.mapService.getMarkerPixelPosition(this.map, marker);
			
			let panX:number = this.position.x - x;
			let panY:number = this.position.y - y;
			
			this.map.panBy(panX, panY);
			
			
			this.syncModal(marker);
			
			this.paramsService.dispatch('openModal', null);
			this.selectedMarker = null;
			this.modalVisible = false;
			
			this.app.tick();
			
			setTimeout(function() {
				this.selectedMarker = marker;
				this.modalVisible = true;
				this.app.tick();
			}.bind(this), 200);
			
	 }
	 
	 closeModal():void
	 {
		 console.log('closeModal');
		 this.selectedMarker = null;
		 this.modalVisible = false;
		 this.paramsService.dispatch('closeModal', null);
		//  this.app.tick();
	 }
	 
	 
	 
	 //depuis company / infos / services
	 private onLocalize(item:Company & InfoService):void
	 {
		let marker = this.markers.find((marker:any) => marker.item == item);
		
		this.map.setZoom(this.LOCALIZE_ZOOM);
		this.onClickMarker(marker);
		
	 }
	 
	 
	 
	 
	 
	 
	 
	 
	 private onGetAddress(location:{lat:number, lng:number, address:string}):void
	 {
		//  debugger;
		 if(this.markerAddress) this.removeMarker(this.markerAddress);
		 
		 let item:any = {
			 title: 'Adresse',
			 desc: location.address,
		 };
		 
		 let latlng:google.maps.LatLng = new google.maps.LatLng(location.lat, location.lng);
		 this.markerAddress = this.addMarker(latlng, 'marker-address', item, 'address', 47, 60);
		 
		 
		 let panX:number = 0;
		 let mobile:boolean = this.breakpointObserver.isMatched('(max-width: 768px)');
		 if(!mobile){
			let openSidebar:boolean = this.paramsService.getData('openSidebar');
			if(openSidebar){
				let width_sidebar:number = 533;
				
				let mapDom = this._elementRef.nativeElement.querySelector('div.map');
				let mapWidth:number = mapDom.clientWidth;
				
				let x:number = width_sidebar + (mapWidth - width_sidebar) * 0.5;
				panX = mapWidth * 0.5 - x;
				
			}
		}
		
		 
		 
		 this.dataService.showAddress = true;
		 this.app.tick();
		 
		 this.map.setZoom(this.LOCALIZE_ZOOM);
		 this.mapService.panToWithOffset(this.map, latlng, panX, 0);
		 
	 }
	 
	 
	 private array2latlng(array:number[]):google.maps.LatLng
	 {
		 return new google.maps.LatLng(array[0], array[1]);
	 }
	 
	 
	 
	 
	 
	 private getClustererStyle(filename:string, multisize:boolean):any
	 {
			let stylebase:any = {
				textColor: 'white',
				fontFamily: 'Roboto',
			};
			
			let sizes:number[][];
			if(filename == 'clusterer' || filename == 'clusterer-service'){
				sizes = [
					[50, 50, 16],
					[63, 63, 20],
					[76, 76, 24],
				];
			}
			else if(filename == 'clusterer-info'){
				sizes = [
					[63, 63, 0.001],
				];
			}
			
			var clusterStyles = sizes.map((size:number[], index:number)=> {
				
				let exts:string[] = ['md', 'xl', 'xxl'];
				let ext:string = multisize ? '-' + exts[index] : '';
				let filename2:string = filename + ext;
				if(this.isRetina){
					filename2 += '@2x';
				}
				
				console.log('filename2 : '+filename2);
				
				let output:any = {
					
					url: 'assets/images/markers/clusterer/'+filename2 + '.png',
					height: size[1], width: size[0],
					textSize:size[2],
					...stylebase
				};
				return output;
			});
			
			return clusterStyles;
	 }
	 
	 
	 private createMarkerClusterer(filename:string, multisize:boolean, gridSize:number):any
	 {
			var mcOptions = {
				gridSize,
				styles: this.getClustererStyle(filename, multisize),
				maxZoom: 15,
				minimumClusterSize:2,
			};
			let mc = new MarkerClusterer(this.map, [], mcOptions);
			
			google.maps.event.addListener(mc, 'clusterclick', function(cluster) {
					console.log('click clusterer');
			});
			
			return mc;
	 }
	 
	 
	 
	 
	 private onMapMove():void
	 {
		 if(this.selectedMarker){
			 
				this.syncModal(this.selectedMarker);
				
		 }
	 }
	 
	 
	 
	 private syncModal(marker:google.maps.Marker):void
	 {
		 	if(this.mobile){
				 this.position = new google.maps.Point(0, 0);
			 }
			else{
				this.position = this.mapService.getMarkerPixelPosition(this.map, marker);
				this.position.x -= 114;
				this.position.y -= this.modalHeight + 54;
			}
			
			// console.log('map move : '+this.position);
			this.app.tick();
	 }
	 
	 
	 
	 
	 
	 
	 private onZoomChange():void
	 {
			var zoom = this.map.getZoom();
			// console.log('onZoomChange '+ zoom);
			
			// let newsize:number = Math2.getProgressionValue(zoom, this.MIN_ZOOM, 20, 9, 60);
			let newsize:number = Math2.getProgressionValue(zoom, 12, 20, 9, 60);
			
			
			for(var k in this.kmlLayers){
				let obj:any = this.kmlLayers[k];
				let marker:google.maps.Marker = obj.marker;
				marker.setIcon(
						new google.maps.MarkerImage(
								(<any>marker.getIcon()).url, //marker's same icon graphic
								null,//size
								null,//origin
								new google.maps.Point(newsize * 0.5, newsize * 1.5 * 0.5), //anchor
								new google.maps.Size(newsize, newsize * 1.5) //changes the scale
						)
				); 
			}
			
			
			if(this.selectedMarker){
				
				 this.syncModal(this.selectedMarker);
				 
			}
	 }
	 
	 
	 
	 onClickRoute(data:any):void
	 {
		 this.modalVisible = false;
	 }

}
